import script from "./TankForecastChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TankForecastChart.vue?vue&type=script&setup=true&lang=js"

import "./TankForecastChart.vue?vue&type=style&index=0&id=dd45bef6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd45bef6"]])

export default __exports__